import React from "react";
import Navbar from "./Navbar/Navbar";
import Footer from "./footer/main";

const Notfound = () => {
  return (
    <div>
      <Navbar />
      <div className="container">
        <h1 className="container mt_10rem ">No page Found!!</h1>
        <a href="/">
          <button type="button" class="btn btn-outline-dark mb_6rem ">
            Go Back
          </button>
        </a>
      </div>

      <Footer />
    </div>
  );
};

export default Notfound;
